/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Targetagefrom2Inputs */

const en_targetagefrom2 = /** @type {(inputs: Targetagefrom2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From`)
};

const de_targetagefrom2 = /** @type {(inputs: Targetagefrom2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von`)
};

/**
* | output |
* | --- |
* | "From" |
*
* @param {Targetagefrom2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const targetagefrom2 = /** @type {((inputs?: Targetagefrom2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Targetagefrom2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_targetagefrom2(inputs)
	return de_targetagefrom2(inputs)
});
export { targetagefrom2 as "targetAgeFrom" }